import React from "react";
import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import RuleBlock from "./RuleBlock";
import WithTooltip from "./WithTooltip";
import { OPERATOR_OPTIONS } from "../constants";

const NO_VALUE_OPERATORS = ["is null", "is not null"];

export default function ConditionRuleSection({
  selectedColumn,
  hasColumn,
  operator,
  value,
  updateData,
  openColumnModal,
  buttonSx,
  inputSx,
  selectSx,
  disabledSx,
 
  showErrors,
  isIncomplete,
  operatorNeedsValue,
}) {
  const shouldShowValue =
    operator && !NO_VALUE_OPERATORS.includes(operator);

  const fieldSx = {
    width: { xs: "100%", md: 320 },
    flexShrink: 0,
  };

  const showLocalError = showErrors && isIncomplete;

  const operatorError = showLocalError && !operator;
  const valueError = showLocalError && operatorNeedsValue && !value?.trim();

  return (
    <Box>
      <RuleBlock
        title="Regra por condição"
        description="Filtre clientes por uma coluna específica (ex: status, plano, tipo, etc)."
        buttonText={
          selectedColumn
            ? `Coluna: ${selectedColumn.title}`
            : "Selecionar coluna da regra"
        }
        onClickButton={() => openColumnModal("ruleColumn")}
        buttonSx={buttonSx(Boolean(selectedColumn))}
        onClear={
          selectedColumn
            ? () =>
                updateData({
                  ruleColumnId: null,
                  operator: "",
                  value: "",
                })
            : null
        }
      >
        {/* Operador */}
        <Box sx={fieldSx}>
          <WithTooltip
            enabled={hasColumn}
            title="Selecione uma coluna de regra primeiro"
          >
            <Select
              fullWidth
              disabled={!hasColumn}
              displayEmpty
              value={operator}
              onChange={(e) =>
                updateData({
                  operator: e.target.value,
                  ...(NO_VALUE_OPERATORS.includes(e.target.value) && {
                    value: "",
                  }),
                })
              }
              error={operatorError}
              sx={{
                ...selectSx,
                ...(!hasColumn ? disabledSx : {}),
              }}
            >
              <MenuItem value="" disabled>
                Operador
              </MenuItem>

              {OPERATOR_OPTIONS.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </WithTooltip>

          {operatorError && (
            <Typography sx={{ color: "error.main", fontSize: 12, mt: 0.5 }}>
              Selecione um operador
            </Typography>
          )}
        </Box>

        {/* Valor */}
        {shouldShowValue && (
          <Box sx={fieldSx}>
            <TextField
              fullWidth
              disabled={!hasColumn}
              label="Valor"
              placeholder="Ex: ATIVO"
              value={value}
              onChange={(e) => updateData({ value: e.target.value })}
              error={valueError}
              helperText={valueError ? "Informe um valor" : ""}
              sx={{
                ...inputSx,
                ...(!hasColumn ? disabledSx : {}),
              }}
            />
          </Box>
        )}
      </RuleBlock>
    </Box>
  );
}
